import { DateFields, Services } from '@sigma-frontend-libs/commons'
import { EUrlShortenerSettingsDomainsAllowedScopes, OrderDirections } from '@sigmasms/shared-types'

import { serviceTemplate } from '@/utils'

export default {
  mixins: [
    serviceTemplate({
      serviceName: `${Services['url-shortener-settings/domains']}`,

      backendGeneration: 'nest',

      find: {
        defaultFilter: {
          order: [ [ DateFields.createdAt, OrderDirections.DESC ] ],
          scopes: [ EUrlShortenerSettingsDomainsAllowedScopes.full ],
          search: undefined,
          id: undefined,
          ownerId: undefined,
          name: undefined,
          state: undefined,
          createdAtPreset: undefined,
          createdAt: {
            gte: undefined,
            lt: undefined
          }
        }
      },
      remove: false,

      has: {
        tabs: false,
        clone: false
      },

      formClass: '',
      titlePath: 'name',
      width: 450
    })
  ]
}
